import {combineReducers} from "@reduxjs/toolkit";
import authReducer from '../slices/authSlice';
import cartReducer from "../slices/cartSlice";
import profileReducer from "../slices/profileSlice";
import courseReducer from "../slices/courseSlice";
import viewCourseSlice from "../slices/viewCourseSlice";

const rootReducer=combineReducers({
    auth: authReducer,
    profile:profileReducer,
    cart:cartReducer,
    course:courseReducer,
    viewCourse:viewCourseSlice
})

export default rootReducer; 